<div class="px-3 py-2">
	<h4 align="center">PQCifris 2019</h4>
	<p>Il <b> 9 maggio 2019</b> si è svolto a Roma l'evento PQCifris 2019, 
		primo incontro tra i partecipanti PQCifris della costituenda 
		Associazione De Componendis Cifris.</p>
	<p>Luogo CONSOB:</p>
	<ul>
		<li>sede di Roma - Via Giovanni Battista Martini, 3;</li>
		<li>sede di Milano (in videoconferenza) - Via Broletto, 7.</li>
	</ul>
	<br>
	<h6><a href="../../../../assets/eventi/2019/RomaPQCifris/PQCifris.pdf">LOCANDINA EVENTO</a></h6>
	<p>Questo evento ha offerto una panoramica sulle attività riguardanti 
		le codifiche Quantum Safe.	È stata inoltre l'occasione per presentare 
		l'iniziativa PQCifris, coordinata dal Prof. Marco Baldi.</p>
		<h5>PROGRAMMA</h5>
		<ul>
			<li>
				<p><b>10:30-11:30 Sessione I</b></p>
				<ul class="ulSon">
					<li>
						<p>
							10:30 Prof. Massimiliano Sala<br>
							De Componendis Cifris <br>
							<i style="color: green;">Acting Director</i><br>
							<a href="../../../../assets/eventi/2019/RomaPQCifris/MSALA_PQCifris.pdf">slide</a>
						</p>
					</li>
					<li>
						<p>
							10:50 Prof. Marco Baldi<br>
							Università Politecnica delle Marche
							<a href="../../../../assets/eventi/2019/RomaPQCifris/MBALDI.pdf">Panorama della Crittografia Post-Quantum</a>
						</p>
					</li>
					<li>
						<p>
							11:15 Dott. Nadir Murru<br>
							Politecnico di Torino <br>
							<a href="../../../../assets/eventi/2019/RomaPQCifris/NMURRU.pdf">I Codici Post-Quantum basati sui reticoli</a>
						</p>
					</li>
					<li>
							<p>11:30 Video di presentazione dei ricercatori PQCifris all'estero </p>
					</li>
				</ul>
			</li>
			<li><p><b>11:45 -12:00   Coffee break</b></p></li>
			<li>
				<p><b>12:00-12:30 Sessione II</b></p>
				<ul class="ulSon">
					<li>
						<p>
							12:00 Prof. Gerardo Pelosi <br>
							Politecnico di Milano <br>
							<a href="../../../../assets/eventi/2019/RomaPQCifris/GPELOSI.pdf">Stato dell'arte della Crittografia basata su Codici</a>
						</p>
					</li>
					<li>
						<p>
							12:15 Dott. Guglielmo Morgari <br>
							Telsy <br>
							<a href="../../../../assets/eventi/2019/RomaPQCifris/GMORGARI.pdf">La Crittografia Post-Quantum nell'Industria</a>
						</p>
					</li>
					<li>
						<p>
							12:30 Dott.ssa Giulia Traverso <br>
							Arcatrust.io <br>
							<a href="../../../../assets/eventi/2019/RomaPQCifris/GTRAVERSO.pdf">Arcatrust e la crittografia Quantum Safe</a>
						</p>
					</li>
					<li>
						<p>
							12:30 Dott. Tommaso Gagliardoni <br>
							Kudelski Security <br>
							<a href="../../../../assets/eventi/2019/RomaPQCifris/Gagliardoni_Tommaso.pdf">Firme digitali basate su funzioni hash</a>
						</p>
					</li>
				</ul>
			</li>
		</ul>
		<hr>
		<p>Eventuali richieste possono essere inviate a: <a href="cifrischain@decifris.it">pqcifris&#64;decifris.it.</a></p>
		<p>Questo evento è stato pianificato dall'Acting Director della De Componendis 
			Cifris e dal Coordinatore di PQCifris. </p>
</div>